/**
 * File floorplan-scripts.js.
 *
 * Handles floorplan page events
 *
 */

(function ($) {
  let $imgClick = $('.floorplan__section--content--column-link'),
    $modalFloorplan = $('.modal-floorplan'),
    $srcImage = $('#modal-floorplan-image img'),
    $imageContainer = $('.modal-floorplan__container--inner--image'),
    $closeButton = $('.modal-floorplan__container--inner--btn--close');

  if (!$imgClick.length || !$modalFloorplan.length) {
    return;
  }

  $imgClick.on('click', function (e) {
    $this = $(e.target);
    $modalFloorplan.fadeIn('slow');
    $srcImage.attr('src', $(this).data('url'));
    setTimeout(function () {
      $imageContainer.toggleClass('show-item-now');
      $closeButton.toggleClass('show-item-now');
    }, 800);
  });

  $closeButton.on('click', function (e) {
    $this = $(e.target);
    $closeButton.toggleClass('show-item-now');
    $imageContainer.toggleClass('show-item-now');
    $modalFloorplan.fadeOut();
  });
})(jQuery);
